import React, { useRef, useState, useEffect, useContext, useCallback, useMemo} from 'react';
import { flushSync } from 'react-dom';
import { useLocation } from 'react-router-dom';
import { Button } from 'primereact/button';
import { SplitButton } from 'primereact/splitbutton';
import { Fieldset } from 'primereact/fieldset';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from "primereact/checkbox";
import { Menu } from 'primereact/menu';
import axios from "axios";

import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";

import { BarrioContext } from "../components/BarrioContext"; // ruta a tu provider
import { useAuth } from "../components/AuthContext";
import { useTerminologia } from "../hooks/useTerminologia";

import { ProgressSpinner } from 'primereact/progressspinner';


import { Toast } from 'primereact/toast';
import { confirmPopup } from 'primereact/confirmpopup';

import ReportePDF from "../components/reportePDF/ReportePDF";
import { fetchLiquidacionPdfData, generarPdfBase64 } from "../utilities/liquidacionPdf";
import { guardarLiquidacionPdf } from "../service/LiquidacionBarrioPdfService";
import { getMailTemplates } from "../service/MailTemplateService";
import { getPersonasBarrio } from "../service/DashboardService";

const Expensas = () => {
    const initialFormData = {
      proveedorId: null,
      comprobante: "",
      detalle: "",
      esPrevision: false,
      esFondoManiobra: false,
      esRestarEmpresaOrdinaria: false,
      // …otros campos que tengas en `campos`
    };
    const initialFormDataExpensas = {
      expensaExtraordinaria: 0,
    };
    const toast = useRef(null);
    const [campos, setCampos] = useState([]);
    //const [formData, setFormData] = useState({});
    const [formData, setFormData] = useState(initialFormData);
    const [formDataExpensas, setFormDataExpensas] = useState(initialFormDataExpensas);
    const [visibleLiquidarExpensa, setVisibleLiquidarExpensa] = useState(false);
    const [enviarMailLiquidacion, setEnviarMailLiquidacion] = useState(true);
    const pdfRef = useRef(null);
    const [pdfDataLiquidacion, setPdfDataLiquidacion] = useState(null);
    const [opciones, setOpciones] = useState({}); // almacena combos dinámicos
    const [editingId, setEditingId] = useState(null); // null = nuevo, != null = edita
    

    const { barrio } = useContext(BarrioContext);
    const { administracionId } = useAuth();
    const t = useTerminologia();

    const [visible, setVisible] = useState(false);

    const location = useLocation();
    const [selectedDate, setSelectedDate] = useState(location.state?.selectedDate ?? new Date());

    const [openDialog, setOpenDialog] = useState(false);
    const [selectedId, setSelectedId] = useState(null);

     
    const HOST_API = process.env.REACT_APP_URL;
    const urlGastosDelete = `${HOST_API}api/gastoBarrio/deleteGasto`;
    const urlSaveGastos = `${HOST_API}api/gastoBarrio/saveGasto`;
    const urlProveedores = `${HOST_API}api/proveedores/getProveedores?proveedorId=0`;
    const excludedCampos = ["proveedorId", "fechaAlta", "usuario"];
    
    // const [totalGasto, setTotalGasto] = useState([]);
    // const [prevision, setPrevision] = useState([]);
    // const [totalPrevision, setTotalPrevision] = useState([]);

    const [expensas, setExpensas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [gruposGasto, setGruposGasto] = useState([]);



    const handleNuevoGasto = () => {
      setEditingId(null);          // modo alta
      setFormData({});             // limpiás el form
      setVisible(true);            // abrís el dialog
    };

    const handleDateChange = (value) => {
      setSelectedDate(value);
    };

    const handleEditarGasto = (rowData) => {
      setEditingId(rowData.id); // o la PK que uses

      setFormData({
        ...initialFormData,    // para asegurar que todos los campos existen
        ...rowData,
        // convertir strings de fecha a Date para el <Calendar />
        liqGastoId: rowData.id,
        fecha: rowData.fecha ? new Date(rowData.fecha) : null,
        fechaAlta: rowData.fechaAlta ? new Date(rowData.fechaAlta) : null,
        proveedorId: Number(rowData.proveedorId ?? rowData.proveedor?.proveedorId ?? null),
        // asegurar booleanos
        esPrevision: !!rowData.esPrevision,
        esFondoManiobra: !!rowData.esFondoManiobra,
        esRestarEmpresaOrdinaria: !!rowData.esRestarEmpresaOrdinaria,
      });

      setVisible(true);
    };  

    const [loadingBackdrop, setLoadingBackdrop] = useState(false);


  const formatDate = (date) => {
    if (!date) return "";

    const year  = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day   = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      ...formData,
      // fechas, números, checkboxes, etc...
    };

    try {
      // if (editingId) {
      //   // 🔁 Modo edición
      //   await axios.put(`${HOST_API}api/gastoBarrioZaputovich/${editingId}`, payload);
      // } else {
      //   // ➕ Modo alta
      // }
      
      await axios.post(`${HOST_API}api/expensaBarrio`, payload);
      setVisible(false);   // cerrar dialog
      fetchExpensas();       // refrescar la grilla (la que armamos antes con useCallback)

    } catch (err) {
      console.error(err);
    }
  };

  const handleSubmitExpensas = async (e) => {
    e.preventDefault();

    const user = JSON.parse(localStorage.getItem("user"));
    const usuarioId = user.id ?? user.usuarioId;

    const payload = {
        ...formDataExpensas,

        barrioId: barrio.id,
        usuarioId,

        periodo: selectedDate,
        administracionId
      };

      setLoadingBackdrop(true);

      try {
        // 1) Liquidar (calcula los importes por UF, como ya hacía)
        await axios.post(
          `${HOST_API}api/expensaBarrio/liquidar`,
          payload,
          {
            headers: { "Content-Type": "application/json" },
          }
        );

        // 2) Traer los mismos datos que arma el PDF de liquidacion y renderizarlo off-screen
        const data = await fetchLiquidacionPdfData(barrio.id, administracionId, selectedDate);
        flushSync(() => setPdfDataLiquidacion(data));
        const pdfBase64 = await generarPdfBase64(pdfRef.current);

        // 3) Si corresponde, armar destinatarios/plantilla de mail
        let destinatarios = [];
        let mailAsunto = '';
        let mailHtmlTemplate = '';
        const periodoStr = selectedDate.toLocaleDateString('es-AR', { month: 'long', year: 'numeric' });
        const barrioNombre = barrio?.nombre || `el ${t.barrio}`;

        if (enviarMailLiquidacion) {
          const { data: templates } = await getMailTemplates(administracionId, barrio.id);
          const envioMail = templates.find((tpl) => tpl.tipoMail === 'EnvioMail');
          mailAsunto = envioMail?.asunto || '';
          mailHtmlTemplate = envioMail?.htmlTemplate || '';

          const { data: personasData } = await getPersonasBarrio(barrio.id, administracionId);
          destinatarios = personasData
            .filter((p) => p.email)
            .map((p) => ({ email: p.email, placeholders: { nombrePersona: p.nombreCompleto || 'propietario/a' } }));
        }

        // 4) Guardar el PDF en el servidor (y enviar por mail si corresponde)
        const { data: resultado } = await guardarLiquidacionPdf({
          administracionId,
          barrioId: barrio.id,
          periodo: selectedDate,
          usuarioId,
          pdfBase64,
          enviarMail: enviarMailLiquidacion,
          mailAsunto,
          mailHtmlTemplate,
          placeholdersComunes: { barrio: barrioNombre, periodo: periodoStr },
          destinatarios,
        });

        toast.current.show({
          severity: "success",
          summary: "Liquidar Expensas",
          detail: enviarMailLiquidacion
            ? `Liquidación generada y enviada a ${resultado.enviados} destinatario(s).`
            : "Liquidación generada. El PDF ya está disponible para los propietarios.",
          life: 3000,
        });

        setVisibleLiquidarExpensa(false);
        fetchExpensas();
      } catch (err) {
        toast.current.show({
          severity: "error",
          summary: "Liquidar Expensas - Error",
          detail: "Error al liquidar/generar el PDF de la expensa",
          life: 3000,
        });
        console.error("❌ Error al liquidar expensas:", err);
      } finally {
        setLoadingBackdrop(false);
      }
    };

  const handleChangeLiquidarExpensa = (campo, valor) => {
    setFormDataExpensas((prev) => ({
      ...prev,
      [campo]: valor,
    }));
  };

  // handler para actualizar formData
  const handleChange = (campo, valor) => {
    setFormData((prev) => ({
      ...prev,
      [campo]: valor,
    }));
  };

  const handleProveedorChange = (e) => {
    const proveedorId = e.value;

    setFormData((prev) => ({
      ...prev,
      proveedorId: e.value, // guardamos el id seleccionado
    }));

    console.log("✅ Proveedor seleccionado:", proveedorId);
  };

  const handleDelete = (liqGastoId) => {
    confirmDialog({
      message: '¿Estás seguro de eliminar este gasto?',
      header: 'Confirmación',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Eliminar',
      rejectLabel: 'Cancelar',
      accept: () => deleteGasto(liqGastoId),
    });
  };

  const deleteGasto = async (liqGastoId) => {
    try {
      const response = await fetch(`${urlGastosDelete}/${liqGastoId}`, {
        method: "DELETE",
      });

      if (!response.ok) {
        throw new Error("Error al eliminar el gasto");
      }

      setExpensas((prev) => prev.filter((g) => g.liqGastoId !== liqGastoId));
    } catch (error) {
      console.error("Error eliminando gasto:", error);
    }
  };

const handleModify = (liqGastoId) => {
  confirmDialog({
    message: '¿Estás seguro de eliminar este gasto?',
    header: 'Confirmación',
    icon: 'pi pi-exclamation-triangle',
    acceptLabel: 'Eliminar',
    rejectLabel: 'Cancelar',
    accept: () => deleteGasto(liqGastoId),
  });
};


const getOpcionesCombo = (tablaCombo) => {
  switch (tablaCombo) {
    case "Proveedores":
      return proveedores;
    case "EstadosPago":
      return [
        { id: 2, descripcion: "Pendiente" },
        { id: 1, descripcion: "Pagado" },
      ];
    case "GrupoGastoBase":
      return [
        {id:3, descripcion: "Impuestos y Servicios"},
        {id:7, descripcion: "Seguridad Privada"},
        {id:8, descripcion: "Seguros"},
        {id:4, descripcion: "Mantenimiento y Abonos"},
        {id:5, descripcion: "Reparaciones"},
        {id:2, descripcion: "Gastos Bancarios, Legales, Administrativos y Registrales"},
        {id:1, descripcion: "Aportes y Cargas Sociales"},
        {id:6, descripcion: "Remuneraciones"}
      ];
    default:
      return [];
  }
};

  const grupos = {
      3: "Impuestos y Servicios",
      7: "Seguridad Privada",
      8: "Seguros",
      4: "Mantenimiento y Abonos",
      5: "Reparaciones",
      2: "Gastos Bancarios, Legales, Administrativos y Registrales",
      1: "Aportes y Cargas Sociales",
      6: "Remuneraciones"
  };

   const fetchExpensas = useCallback(async () => {
      if (!selectedDate || !barrio?.id) return;

      setLoadingBackdrop(true);
      try {
        const fecha = formatDate(selectedDate);

        const urlGastos = `${HOST_API}api/expensaBarrio/getByBarrio`;

        const body = {
          barrioId: barrio.id,
          periodo: fecha,
          administracionId
        };

        const response = await axios.post(urlGastos, body);
        
        console.log(response.data);
        setExpensas(response.data);


      } catch (err) {
        setError(err.message || "Error al obtener gastos");
      } finally {
        setLoading(false);
        setLoadingBackdrop(false);
      }
    }, [selectedDate, barrio?.id, administracionId]);

    useEffect(() => {
      fetchExpensas();
    }, [fetchExpensas]);


    const [proveedores, setProveedores] = useState([]);
    const [estadosPago, setEstadosPago] = useState([]);
    const [barrios, setBarrios] = useState([]);
    //const [grupos, setGrupos] = useState([]);
    const [usuarios, setUsuarios] = useState([]);

    const menu1 = useRef(null);
    const toolbarItems = [
        {
            label: 'Save',
            icon: 'pi pi-check'
        },
        {
            label: 'Update',
            icon: 'pi pi-upload'
        },
        {
            label: 'Delete',
            icon: 'pi pi-trash'
        },
        {
            label: 'Home Page',
            icon: 'pi pi-home'
        }
    ];


    const flattenRow = (row) => {
      const flat = {};
      for (const [key, value] of Object.entries(row)) {
        if (typeof value === "object" && value !== null && !key.endsWith("_type")) {
          for (const [nestedKey, nestedValue] of Object.entries(value)) {
            flat[nestedKey] = nestedValue;
            flat[`${nestedKey}_type`] = row[`${key}_type`] ?? "currency";
          }
        } else {
          flat[key] = value;
        }
      }
      return flat;
    };

    const expensasFlat = useMemo(() => expensas?.map(flattenRow) ?? [], [expensas]);    

    const camelToHeader = (key) => {
      return key
        .replace(/([A-Z])/g, " $1")       // inserta espacio antes de cada mayúscula
        .replace(/^./, (str) => str.toUpperCase()) // capitaliza la primera letra
        .trim();
    };

    // Función para formatear el valor según el tipo
    const formatValue = (value, type) => {
      if (value === null || value === undefined) return "";

      switch (type) {
        case "date":
          return new Date(value).toLocaleDateString("es-AR");
        case "currency":
          return typeof value === "number"
            ? value.toLocaleString("es-AR", { style: "currency", currency: "ARS" })
            : value;
        default:
          // Si por alguna razón llega un objeto, lo serializa en lugar de romper
          return typeof value === "object" ? JSON.stringify(value) : value;
      }
    };

    // Derivar columnas dinámicas a partir del primer row
    const columns = useMemo(() => {
      if (!expensasFlat?.length) return [];

      const firstRow = expensasFlat[0];

      return Object.keys(firstRow)
        .filter((key) => !key.endsWith("_type") && key !== 'unidadFuncionalMostrar') // excluir las keys de tipo
        .map((field) => ({
          field,
          type: firstRow[`${field}_type`] ?? "text",
          header: camelToHeader(field), // podés mapear a un label más amigable si querés
        }));
    }, [expensas]);

    const [globalFilter, setGlobalFilter] = useState(null);

    const header = (
            <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                <h5 className="m-0">Expensas</h5>
                <span className="block mt-2 md:mt-0 p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Buscar..." />
                </span>
            </div>
        );

    if (!barrio?.id) {
      return (
        <div className="flex flex-column align-items-center justify-content-center" style={{ minHeight: '50vh', textAlign: 'center' }}>
          <i className="pi pi-map-marker" style={{ fontSize: '2.5rem', color: '#98a2b3', marginBottom: '1rem' }} />
          <h4 style={{ margin: 0 }}>Seleccioná un {t.barrio}</h4>
          <p style={{ color: '#667085', maxWidth: 360 }}>
            Elegí un {t.barrio} en el selector de la barra superior para ver las expensas.
          </p>
        </div>
      );
    }

    return (
      <>
        <h4>Expensas</h4>
        <br />

        <ConfirmDialog />
        <Toast ref={toast} />

        {/* Wrapper off-screen: se usa solo para generar el PDF de la liquidación */}
        <div style={{ position: 'absolute', left: '-9999px', top: 0, width: '210mm' }}>
          <div ref={pdfRef}>
            <ReportePDF barrio={barrio} periodo={selectedDate} pdfData={pdfDataLiquidacion} />
          </div>
        </div>

        <Dialog
          visible={loadingBackdrop}
          modal 
          closable={false} 
          // showHeader={false}
          header={editingId ? "Expensas" : "Expensas"}
          className="backdrop-dialog"
        >
          <ProgressSpinner style={{ width: '60px', height: '60px' }} />
        </Dialog>

        <div className="flex align-items-center gap-3">

    {/* Botones uno al lado del otro */}
        <div className="flex gap-2">
              {/* <Button
                  label="Nueva Expensas"
                  icon="pi pi-plus"
                  onClick={() => setVisible(true)}
              /> */}

              <Button
                  label="Liquidar expensas"
                  icon="pi pi-shopping-cart"
                  onClick={() => setVisibleLiquidarExpensa(true)}
              />
          </div>

          {/* Calendar al lado */}
          <Calendar
              value={selectedDate}
              view="month"
              dateFormat="mm/yy"
              onChange={(e) => handleDateChange(e.value)}
              showIcon
              className="p-inputtext-sm"
          />
      </div>

      <br></br>

        <div className="grid">
            {/* <div className="col-12 md:col-4">
                    <div className="card widget-overview-box widget-overview-box-2" style={{ border: "1px solid lightgray" }}>
                        <span className="overview-title">Total</span>
                        <div className="flex justify-content-between">
                            <div className="overview-detail flex justify-content-between">
                                <div className="overview-text">$
                                {Number(totalGasto).toLocaleString("es-ES")}
                                </div>
                            </div>
                        </div>
                        <img src="assets/layout/images/dashboard/value.svg" alt="value" />
                    </div>
            </div>
            <div className="col-12 md:col-4">
                    <div className="card widget-overview-box widget-overview-box-2" style={{ border: "1px solid lightgray" }}>
                        <span className="overview-title">Previsión</span>
                        <div className="flex justify-content-between">
                            <div className="overview-detail flex justify-content-between">
                                <div className="overview-text">$
                                  {Number(prevision).toLocaleString("es-ES")}
                                </div>
                            </div>
                        </div>
                        <img src="assets/layout/images/dashboard/value.svg" alt="value" />
                    </div>
            </div>
            <div className="col-12 md:col-4">
                    <div className="card widget-overview-box widget-overview-box-2" style={{ border: "1px solid lightgray" }}>
                        <span className="overview-title">Total + Previsión</span>
                        <div className="flex justify-content-between">
                            <div className="overview-detail flex justify-content-between">
                                <div className="overview-text">$
                                {Number(totalPrevision).toLocaleString("es-ES")}
                                </div>
                            </div>
                        </div>
                        <img src="assets/layout/images/dashboard/value.svg" alt="value" />
                    </div>
            </div> */}
            <Dialog
                header="Expensas"
                visible={visible}
                style={{ width: "70vw" }}
                breakpoints={{ "960px": "100vw" }} // responsive en mobile
                modal
                onHide={() => setVisible(false)}
            >
            <Card className="p-3">
              <form className="p-fluid grid" onSubmit={handleSubmit}>
                {/* 👇 Fila de Dropdowns */}
                <div className="col-12 flex flex-wrap gap-3">
                  {/* Dropdown Proveedor fijo */}
                  <div className="flex-1 min-w-[200px]">
                    <label>Proveedor *</label>
                    <Dropdown
                      value={formData.proveedorId || null}
                      options={proveedores}
                      optionValue="proveedorId"
                      optionLabel="nombreProveedor"
                      onChange={handleProveedorChange}
                      placeholder="Seleccione"
                      className="p-inputtext-sm w-full"
                    />
                  </div>

                  {/* Resto de dropdowns dinámicos */}
                  {campos
                    .filter(
                      (campo) =>
                        campo.EsCombo && !excludedCampos.includes(campo.NombreCampo)
                    )
                    .sort((a, b) => a.Orden - b.Orden)
                    .map((campo) => (
                      <div key={campo.NombreCampo} className="flex-1 min-w-[200px]">
                        <label>
                          {campo.Label}
                          {campo.EsRequerido && " *"}
                        </label>
                        <Dropdown
                          value={formData[campo.NombreCampo] || null}
                          options={getOpcionesCombo(campo.TablaCombo)}
                          optionValue={campo.CampoValorCombo}
                          optionLabel={campo.CampoTextoCombo}
                          onChange={(e) => handleChange(campo.NombreCampo, e.value)}
                          placeholder="Seleccione"
                          className="p-inputtext-sm w-full"
                        />
                      </div>
                    ))}
                </div>

                {/* 👇 Fila comprobante + detalle */}
                <div className="col-12 flex flex-wrap gap-3 mt-3">
                  <div className="w-full md:w-4">
                    <label>Comprobante</label>
                    <InputText
                      type="text"
                      value={formData.comprobante || ""}
                      onChange={(e) => handleChange("comprobante", e.target.value)}
                      className="p-inputtext-sm w-full"
                    />
                  </div>
                  <div className="w-full md:w-8">
                    <label>Detalle</label>
                    <InputText
                      type="text"
                      value={formData.detalle || ""}
                      onChange={(e) => handleChange("detalle", e.target.value)}
                      className="p-inputtext-sm w-full"
                    />
                  </div>
                </div>

                {/* 👇 Resto de los campos */}
                {campos
                  .filter(
                    (campo) =>
                      !campo.EsCombo &&
                      !["comprobante", "detalle"].includes(campo.NombreCampo) &&
                      !excludedCampos.includes(campo.NombreCampo)
                  )
                  .sort((a, b) => a.Orden - b.Orden)
                  .map((campo) => (
                    <div key={campo.NombreCampo} className="col-12 md:col-3 lg:col-2">
                      <label>
                        {campo.Label}
                        {campo.EsRequerido && " *"}
                      </label>

                      {campo.TipoCampo === "date" ? (
                        <Calendar
                          value={formData[campo.NombreCampo] || null}
                          onChange={(e) => handleChange(campo.NombreCampo, e.value)}
                          showIcon
                          className="p-inputtext-sm"
                        />
                      ) : (
                        <InputText
                          type={campo.TipoCampo === "number" ? "number" : "text"}
                          value={formData[campo.NombreCampo] || ""}
                          onChange={(e) => handleChange(campo.NombreCampo, e.target.value)}
                          className="p-inputtext-sm"
                        />
                      )}
                    </div>
                  ))}


                <div className="col-12 flex flex-wrap gap-4 mt-3">
  
                  <div className="flex align-items-center gap-2">
                    <Checkbox 
                      inputId="esPrevision" 
                      checked={formData.esPrevision || false} 
                      onChange={(e) => handleChange("esPrevision", e.checked)} 
                    />
                    <label htmlFor="esPrevision">Es Previsión</label>
                  </div>

                  <div className="flex align-items-center gap-2">
                    <Checkbox 
                      inputId="esFondoManiobra" 
                      checked={formData.esFondoManiobra || false} 
                      onChange={(e) => handleChange("esFondoManiobra", e.checked)} 
                    />
                    <label htmlFor="esFondoManiobra">Es Fondo Maniobra</label>
                  </div>

                  <div className="flex align-items-center gap-2">
                    <Checkbox 
                      inputId="esRestarEmpresaOrdinaria" 
                      checked={formData.esRestarEmpresaOrdinaria || false} 
                      onChange={(e) => handleChange("esRestarEmpresaOrdinaria", e.checked)} 
                    />
                    <label htmlFor="esRestarEmpresaOrdinaria">
                      Gasto a Restar Empresa Ordinaria
                    </label>
                  </div>

                </div>

                {/* Botón guardar */}
                <div className="col-12 mt-3">
                  <Button label="Guardar" icon="pi pi-save" type="submit" />
                </div>
              </form>


            </Card>
            </Dialog>

            <Dialog
                header="Liquidar Expensas"
                visible={visibleLiquidarExpensa}
                style={{ width: "70vw" }}
                breakpoints={{ "960px": "100vw" }} // responsive en mobile
                modal
                onHide={() => setVisibleLiquidarExpensa(false)}
            >
              <form className="p-fluid grid" onSubmit={handleSubmitExpensas}>
                <div className="col-12 md:col-12">
                  <div className="col-12 flex flex-wrap gap-3 mt-3">
                    <div className="w-full md:w-4">
                      <label>Expensa Extraordinaria</label>
                      <InputText
                        type="text"
                        value={formDataExpensas.expensaExtraordinaria || ""}
                        onChange={(e) => handleChangeLiquidarExpensa("expensaExtraordinaria", e.target.value)}
                        className="p-inputtext-sm w-full"
                      />
                    </div>

                    <div className="w-full md:w-4">
                      <label>Fecha de vencimiento</label>
                      <Calendar
                            value={selectedDate}
                            dateFormat="dd/mm/yy"
                            onChange={(e) => handleChangeLiquidarExpensa("fechaVencimiento", e.target.value)}
                            showIcon
                            className="p-inputtext-sm"
                        />
                    </div>

                    <div className="col-12 flex align-items-center gap-2 mt-2">
                      <Checkbox
                        inputId="enviarMailLiquidacion"
                        checked={enviarMailLiquidacion}
                        onChange={(e) => setEnviarMailLiquidacion(e.checked)}
                      />
                      <label htmlFor="enviarMailLiquidacion">Enviar por mail a los propietarios</label>
                    </div>

                    <div className="col-12 mt-3">
                      <Button label="Liquidar y generar PDF" icon="pi pi-save" type="submit" loading={loadingBackdrop} />
                    </div>

                  </div>
                </div>
              </form>
            </Dialog>

            <div className="col-12 md:col-12">

              <DataTable
                value={expensasFlat}
                paginator
                rows={10}
                globalFilter={ globalFilter }
                // header={ header }
                showGridlines
                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                responsiveLayout="scroll"
                emptyMessage="No hay expensas cargadas"
                className="p-datatable-gridlines bg-white"
              >
                {columns.map(({ field, header, type }) => (
                  <Column
                    key={field}
                    field={field}
                    header={header}
                    sortable
                    body={(row) => formatValue(row[field], type)}
                  />
                ))}
              </DataTable>

                {/* <DataTable
                  value={expensas}
                  paginator
                  rows={10}
                  showGridlines
                  rowsPerPageOptions={[5, 10, 25, 50, 100]}
                  responsiveLayout="scroll"
                  emptyMessage="No hay expensas cargadas"
                  className="p-datatable-gridlines bg-white"
                >
                  <Column field="unidadFuncional" header={t.UnidadFuncional} sortable />
                  <Column field="propietario" header="Propietario" sortable />

                  <Column
                    field="fechaAlta"
                    header="Fecha Alta"
                    sortable
                    body={(row) =>
                      row.fechaAlta
                        ? new Date(row.fechaAlta).toLocaleDateString("es-AR")
                        : ""
                    }
                  />

                  <Column
                    field="saldoAntProntoPago"
                    header="Saldo Ant. Pronto Pago"
                    sortable
                    body={(row) =>
                      row.saldoAntProntoPago?.toLocaleString("es-AR", {
                        style: "currency",
                        currency: "ARS",
                      })
                    }
                  />

                  <Column
                    field="saldoAntSinProntoPago"
                    header="Saldo Ant. Sin Pronto Pago"
                    sortable
                    body={(row) =>
                      row.saldoAntSinProntoPago?.toLocaleString("es-AR", {
                        style: "currency",
                        currency: "ARS",
                      })
                    }
                  />

                  <Column
                    field="pagoAnt"
                    header="Pago Anterior"
                    sortable
                    body={(row) =>
                      row.pagoAnt?.toLocaleString("es-AR", {
                        style: "currency",
                        currency: "ARS",
                      })
                    }
                  />

                  <Column
                    field="fechaPago"
                    header="Fecha Pago"
                    sortable
                    body={(row) =>
                      row.fechaPago
                        ? new Date(row.fechaPago).toLocaleDateString("es-AR")
                        : ""
                    }
                  />

                  <Column
                    field="subtotal"
                    header="Subtotal"
                    sortable
                    body={(row) =>
                      row.subtotal?.toLocaleString("es-AR", {
                        style: "currency",
                        currency: "ARS",
                      })
                    }
                  />

                  <Column
                    field="intereses"
                    header="Intereses"
                    sortable
                    body={(row) =>
                      row.intereses?.toLocaleString("es-AR", {
                        style: "currency",
                        currency: "ARS",
                      })
                    }
                  />

                  <Column
                    field="expensaOrdinaria"
                    header="Expensa Ordinaria"
                    sortable
                    body={(row) =>
                      row.expensaOrdinaria?.toLocaleString("es-AR", {
                        style: "currency",
                        currency: "ARS",
                      })
                    }
                  />

                  <Column
                    field="expensaExtraordinaria"
                    header="Expensa Extraordinaria"
                    sortable
                    body={(row) =>
                      row.expensaExtraordinaria?.toLocaleString("es-AR", {
                        style: "currency",
                        currency: "ARS",
                      })
                    }
                  />

                  <Column
                    field="recuperoPilara"
                    header="Recupero Pilara"
                    sortable
                    body={(row) =>
                      row.recuperoPilara?.toLocaleString("es-AR", {
                        style: "currency",
                        currency: "ARS",
                      })
                    }
                  />

                  <Column
                    field="recuperoPilaraArba"
                    header="Recupero Pilara ARBA"
                    sortable
                    body={(row) =>
                      row.recuperoPilaraArba?.toLocaleString("es-AR", {
                        style: "currency",
                        currency: "ARS",
                      })
                    }
                  />

                  <Column
                    field="cortePasto"
                    header="Corte de Pasto"
                    sortable
                    body={(row) =>
                      row.cortePasto?.toLocaleString("es-AR", {
                        style: "currency",
                        currency: "ARS",
                      })
                    }
                  />

                  <Column
                    field="cargoPeriodoImporte"
                    header="Cargo Período"
                    sortable
                    body={(row) =>
                      row.cargoPeriodoImporte?.toLocaleString("es-AR", {
                        style: "currency",
                        currency: "ARS",
                      })
                    }
                  />

                  <Column field="cargoPeriodoObs" header="Obs. Cargo Período" sortable />

                  <Column
                    field="totalProntoPago"
                    header="Total Pronto Pago"
                    sortable
                    body={(row) =>
                      row.totalProntoPago?.toLocaleString("es-AR", {
                        style: "currency",
                        currency: "ARS",
                      })
                    }
                  />

                  <Column
                    field="totalSinProntoPago"
                    header="Total Sin Pronto Pago"
                    sortable
                    body={(row) =>
                      row.totalSinProntoPago?.toLocaleString("es-AR", {
                        style: "currency",
                        currency: "ARS",
                      })
                    }
                  />
                </DataTable> */}
            </div>
            
        </div>
        </>
    );
};

export default Expensas;
